/** Inter-Mappa Mare ↔ Terra — stato dashboard (CRA bundle). */

export const LIVELLI = {
  MARE: "MARE_PORTI",
  TERRA: "TERRA_BORGHI",
};

export const FILTRI = [
  "TUTTO",
  "BIKE",
  "MONUMENTI",
  "NEGOZI",
  "HOTEL",
  "PARROCCHIE",
  "PROLOCO",
];

export const DEFAULT_DASHBOARD_STATE = {
  mappaAttiva: LIVELLI.TERRA,
  portoSelezionatoId: null,
  comuneSelezionatoId: null,
  filtroAttivo: "TUTTO",
  macro: "terra",
};

export function livelloFromModeParam(mode) {
  const m = (mode || "").toLowerCase();
  if (m === "mare") return LIVELLI.MARE;
  if (m === "terra") return LIVELLI.TERRA;
  return null;
}

export function filtroFromFocusParam(focus) {
  const f = (focus || "").toLowerCase();
  const map = {
    ebike: "BIKE",
    bike: "BIKE",
    borghi: "TUTTO",
    monumenti: "MONUMENTI",
    negozi: "NEGOZI",
    hotel: "HOTEL",
    parrocchie: "PARROCCHIE",
    proloco: "PROLOCO",
    tutto: "TUTTO",
  };
  return map[f] ?? null;
}

export function modeParamFromLivello(livello) {
  return livello === LIVELLI.MARE ? "mare" : "terra";
}

export function focusParamFromFiltro(filtro) {
  const map = {
    BIKE: "ebike",
    MONUMENTI: "monumenti",
    NEGOZI: "negozi",
    HOTEL: "hotel",
    PARROCCHIE: "parrocchie",
    PROLOCO: "proloco",
  };
  return map[filtro] ?? null;
}
